export default {
    Eng:{ 
        NavHome: "Home", 
        NavProd: "Product", 
        NavDemo: "Demo", 
        NavCont: "Contact",

        Header: "Artificial Intelligence for Aquaculture", 
        Titletag: "Using state-of-the-art algorithms to maximise a farm's potential", CalltoAction: "Get in touch", 

        HelpInfoTitle: 'What we do',
        HelpInfo1:"We use artificial intelligence (AI) to give actionable insights to optimise the biggest costs on fish farms: from feeding to health.",
        HelpInfo2:"Our recommendations have been developed with farmers globally. By monitoring any deviations and abnormalities, our product helps you to manage your fish farm site more efficiently, minimize feed waste and increase profits.",

        FeatureMonitor: {
            title: 'Smart Alerts',
            text: "The system monitors the whole site, learns individual cage behaviour and alerts the farmer about any anomolies."
        }, 
        FeatureRemote:{
            title: 'Remote Management',
            text: "The unification of all the data streams allow you to succintly and securely process how the site is performing from anywhere."
        }, 
        FeatureSust:{
            title: 'Sustainable Goals',
            text: "With the smart use of the data we can increase the sustainable approach of the fish farm."
        }, 
        FeatureNonInv: {
            title: 'No Extra Equipment',
            text: "We sit on top of existing cage hardware - no new investment needed in intricate cage equipment."
        },
        ProcessTitle: 'Our Process',
        Process1: {
            title: 'Aggregate Your Data',
            text: "Our software agreggates all the existing data streams on your site: from vision, sensors, acoustics and many more. Then we carefully extract relevant information in real-time for our AI to analyse."
        }, 
        Process2: {
            title: 'Alert the farmers',
            text: "Our AI immediately informs the farmer when to increase or decrease feeding in order to optimize FCRs and to alert the farmer of any other abnormality."
        }, 
        Process3: {
            title: 'Adaptive Learning',
            text: "The software becomes smarter over time: adaptively learning about the factors important to each cage as well as the whole site."
        }, 
        Process4: {
            title: 'Manage your site from anywhere',
            text: "We use our tools to obtain a real-time view that summarizes the most important details you need to manage your site."
        },
        Demo1:"We are already working with a number of fish farms across the globe",
        Demo2:"Are you interested to find out more?", 
        DemoCall:"Request a Demo", 

        ContactFirst: "First Name", 
        ContactLast: "Last Name", 
        ContactEmail: "Email Address", 
        ContactSub: "Subject",
        ContactContent: "Message",
        ContactSubmit: 'Submit' 
    },
    Esp:{ NavHome:"", NavProd:"", NavDemo:"", NavCont:"",Header:"Bringing Artificial Intellingence to Aquaculture", Titletag:"", CalltoAction:"", HelpInfo1:"",HelpInfo2:"", FeatureMonitor:"", FeatureRemote:"", FeatureSust:"", FeatureNonInv:"",Process1:"", Process2:"", Process3:"", Process4:"",Demo1:"",Demo2:"",DemoCall:"", ContactFirst:"", ContactLast:"", ContactEmail:"", ContactSub:"",ContactContent:""   },
    Nor:{ NavHome:"", NavProd:"", NavDemo:"", NavCont:"",Header:"Bringing Artificial Intellingence to Aquaculture", Titletag:"", CalltoAction:"", HelpInfo1:"",HelpInfo2:"", FeatureMonitor:"", FeatureRemote:"", FeatureSust:"", FeatureNonInv:"",Process1:"", Process2:"", Process3:"", Process4:"",Demo1:"",Demo2:"",DemoCall:"" ,ContactFirst:"", ContactLast:"", ContactEmail:"", ContactSub:"",ContactContent:""   }

}


// WEBPACK FOOTER //
// ./src/text.js